import { Controller } from "@hotwired/stimulus";
import {
  DrivePickerDocsViewElement,
  DrivePickerElement,
} from "@googleworkspace/drive-picker-element/drive-picker";

// Guarded registration — the library's main entry registers these unconditionally at
// module top-level, which throws NotSupportedError if the module evaluates twice
// (Safari bfcache / Turbo snapshot restore). Importing the sub-path avoids that side
// effect; we register here with a get() check so repeat evaluation is a no-op.
if (!customElements.get("drive-picker")) {
  customElements.define("drive-picker", DrivePickerElement);
}
if (!customElements.get("drive-picker-docs-view")) {
  customElements.define("drive-picker-docs-view", DrivePickerDocsViewElement);
}

export default class extends Controller {
  static values = {
    clientId: String,
    projectId: String,
    token: String,
    updateTokenUrl: String,
  };
  static targets = ["picker", "formText"];

  initPicker(event) {
    event.preventDefault();

    if (!this.hasPickerTarget) {
      return;
    }

    const pickerEl = document.createElement("drive-picker");
    if (this.hasTokenValue) {
      pickerEl.setAttribute("oauth-token", this.tokenValue);
    } else {
      pickerEl.setAttribute("scope", "https://www.googleapis.com/auth/drive.readonly");
      pickerEl.setAttribute("client-id", this.clientIdValue);
      pickerEl.setAttribute("app-id", this.projectIdValue);
      pickerEl.addEventListener("picker-oauth-response", this.authenticated.bind(this));
    }

    pickerEl.addEventListener("picker-picked", this.picked.bind(this));

    this.pickerTarget.appendChild(pickerEl);
  }

  authenticated(event) {
    if (!this.hasUpdateTokenUrlValue) {
      return;
    }

    this.tokenValue = event.detail.access_token;
    const pickerEl = document.createElement("drive-picker");
    pickerEl.setAttribute("oauth-token", event.detail.access_token);

    fetch(this.updateTokenUrlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      body: JSON.stringify({
        ns_user: {
          google_drive_token: event.detail.access_token,
          expires_in: event.detail.expires_in,
        },
      }),
    });
  }

  picked(event) {
    const doc = event.detail.docs[0];
    const name = doc.name;
    const url = doc.url;
    const isShared = doc.isShared;

    if (!isShared) {
      this.formTextTarget.querySelector("a").href = `${url}&sharingaction=manageaccess`;
      this.formTextTarget.classList.remove("d-none");
      return;
    } else {
      this.formTextTarget.classList.add("d-none");
    }

    const urlInputName = document.querySelector("#google_drive_url").name;

    document.querySelector("#google_drive_name").value = name;
    document.getElementsByName(urlInputName).forEach(function (input) {
      input.value = url;
    });
  }
}
